<ng-template #loadingSpinnerRef>
    <ng-content></ng-content>
</ng-template>

